
  (function() {
    /* ⚑ INT 2026-09-02: this file used to be an inline <script> inside
       snippets/int-gallery-swatches.liquid. Its 17 Liquid tags now arrive through the JSON
       data island #int-gs-data, which that snippet renders immediately above the
       <script src> that loads this file.
       ⚑ THE TAG IS DELIBERATELY NOT `defer`ed. Execution order relative to the other inline
       scripts on the page is load-bearing: deferring flips window.__intFPLazyInit (a dead
       framed-print branch would come alive) and flips which script owns
       window.__intFixMobileContainerHeight. See APPLIED-PDP-LOAD-SPEED-2026-09-02.md. */
    var INT_GS = (function () {
      try { return JSON.parse(document.getElementById('int-gs-data').textContent); }
      catch (e) { return {}; }
    })();

    var COLOR_POS = INT_GS.colorPos;

    /* INT v14b: Liquid-rendered variant→featured_media map.
       window.meta.product.variants on this site is stripped to
       ["id","price","name","public_title","sku"], so repair routines
       cannot derive variant hero ids from meta. The /products/X.js
       endpoint has the data but fetching it costs a round-trip.
       Emit directly from Liquid instead. Negligible payload (~40
       bytes per variant). */
    window.__intVariantHeroMap = INT_GS.heroMap || {};
    window.__intDefaultVariantId = INT_GS.defaultVariantId;

    /* INT 2026-08-18: this object used to be a second, hand-kept copy of the colour
       map and had drifted (army was #4B5320 here, #3B3F15 everywhere else). It is now
       built from snippets/int-color-map.liquid, the single source. */
    var colors = (function () {
      var o = {}, parts = String(INT_GS.colorMap || '').split(',');
      for (var ci = 0; ci < parts.length; ci++) {
        var kv = parts[ci].split(':');
        if (kv[0]) o[kv[0]] = kv[1];
      }
      return o;
    })();

    document.querySelectorAll('.int-gswatch__label[data-swatch]').forEach(function(el) {
      if (el.style.backgroundColor) return;
      var raw  = el.dataset.swatch || '';
      var slug = raw.toLowerCase().trim().replace(/['/]/g, '').replace(/[\s\-]+/g, '-');
      var hex = colors[slug];
      if (hex) { el.style.setProperty('background-color', hex, 'important'); }
      else {
        var slugNoHyphen = slug.replace(/-/g,''), found = false;
        Object.keys(colors).forEach(function(k) { if (!found && k.replace(/-/g,'') === slugNoHyphen) { el.style.setProperty('background-color', colors[k], 'important'); found = true; } });
        if (!found) console.warn('[INT swatches v18] no color for:', JSON.stringify(raw), '-> slug:', slug);
      }
    });

    /* Show-more */
    (function() {
      var list = document.querySelector('.int-gallery-swatches__list');
      var btns = list ? list.querySelectorAll('.int-gswatch') : [];
      var LIMIT = 12;
      if (!list || btns.length <= LIMIT) return;
      var overflow = btns.length - LIMIT;
      btns.forEach(function(b, i) { if (i >= LIMIT) b.classList.add('int-gswatch--overflow'); });
      var moreBtn = document.createElement('button');
      moreBtn.type = 'button'; moreBtn.className = 'int-gswatch-show-more';
      /* 2026-10-26: the label comes translated from int_pdp.swatches_more via data-more-label
         on #int-gallery-swatches (int-gallery-swatches.liquid); English if it is missing. */
      var _moreTpl = (list.closest('#int-gallery-swatches') || {}).getAttribute ? list.closest('#int-gallery-swatches').getAttribute('data-more-label') : '';
      moreBtn.textContent = _moreTpl && _moreTpl.indexOf('__N__') > -1 ? _moreTpl.replace('__N__', overflow) : '+ ' + overflow + ' more';
      list.appendChild(moreBtn);
      moreBtn.addEventListener('click', function() { list.closest('.int-gallery-swatches').classList.add('int-gallery-swatches--expanded'); });
    })();

    var nameEl  = document.querySelector('.int-gswatch-name');
    var actBtn  = document.querySelector('.int-gswatch--active');
    var actName = actBtn ? (actBtn.getAttribute('title') || '') : '';

    document.querySelectorAll('.int-gswatch').forEach(function(btn) {
      btn.addEventListener('mouseenter', function() { if (nameEl) nameEl.textContent = btn.getAttribute('title') || ''; });
      btn.addEventListener('mouseleave', function() { if (nameEl) nameEl.textContent = actName; });
    });

    /* ══════════════════════════════════════════════════════════════════════
       FRAME COLOR — body class + thumb URL rewrite v1
       StarApps VIA CDN pre-crops all thumbs to ?crop=center&h=144&w=114.
       object-fit:contain alone can't fix a pre-cropped image, so we strip
       the crop param from every thumb src. MutationObserver survives VIA
       DOM rebuilds after swatch clicks.
    ══════════════════════════════════════════════════════════════════════ */
    if (INT_GS.colorOptionName === 'Frame Color') {
      document.body.classList.add('int-frame-color-product');
    }

    /* Remove ?crop=center from ALL product thumbnail URLs — VIA injects
       this on apparel thumbs too, not just framed prints */
    (function() {
      function _intRemoveCrop(url) {
        if (!url || url.indexOf('crop') === -1) return url;
        try {
          var u = new URL(url, window.location.href);
          u.searchParams.delete('crop');
          return u.toString();
        } catch(e) {
          return url.replace(/([&?])crop=[^&]*/g, function(m, sep) {
            return sep === '?' ? '?' : '';
          }).replace(/\?$/, '');
        }
      }
      function _intRewriteThumb(img) {
        var src = img.getAttribute('src');
        if (!src) return;
        var next = _intRemoveCrop(src);
        if (next !== src) img.setAttribute('src', next);
        var ss = img.getAttribute('srcset');
        if (ss && ss.indexOf('crop') !== -1) {
          img.setAttribute('srcset', ss.replace(/([&?])crop=[^&,\s]*/g, function(m, sep) {
            return sep === '?' ? '?' : '';
          }));
        }
      }
      function _intRewriteAllThumbs() {
        document.querySelectorAll(
          '.media__thumb img, .media__thumb__wrapper img, .media__thumb__holder img'
        ).forEach(_intRewriteThumb);
      }
      _intRewriteAllThumbs();
      var _intThumbRoot = document.querySelector(
        '.media__thumb__wrapper, .media__thumb__holder'
      );
      if (_intThumbRoot && !_intThumbRoot.__intCropObserver) {
        _intThumbRoot.__intCropObserver = true;
        var _intCropMo = new MutationObserver(function(muts) {
          muts.forEach(function(mut) {
            mut.addedNodes.forEach(function(node) {
              if (!node || node.nodeType !== 1) return;
              if (node.tagName === 'IMG') { _intRewriteThumb(node); return; }
              if (node.querySelectorAll) {
                node.querySelectorAll('img').forEach(_intRewriteThumb);
              }
            });
            if (mut.type === 'attributes' && mut.target.tagName === 'IMG') {
              _intRewriteThumb(mut.target);
            }
          });
        });
        _intCropMo.observe(_intThumbRoot, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['src', 'srcset']
        });
        if (window.__intCleanupRegistry) {
          window.__intCleanupRegistry.push(function() { _intCropMo.disconnect(); _intThumbRoot.__intCropObserver = false; });
        }
      }
      document.addEventListener('int:gallery:settled', _intRewriteAllThumbs);
      setTimeout(_intRewriteAllThumbs, 1500);
      setTimeout(_intRewriteAllThumbs, 4000);
    })();

    /* ══════════════════════════════════════════════════════════════════════
       DYNAMIC SENTINEL THUMB HIDER
    ══════════════════════════════════════════════════════════════════════ */
    function hideSentinelThumb() {
      var id = window.__intVIASentinel;
      if (!id) return;
      /* Only hide sentinel on framed print pages — on apparel the sentinel
         IS the real size chart thumbnail and must stay visible */
      if (!document.body.classList.contains('int-frame-color-product')) return;
      /* Thumbnails use data-media-select, not data-media-id */
      document.querySelectorAll(
        '.media__thumb[data-media-id="' + id + '"],' +
        '.media__thumb[data-id="' + id + '"],' +
        '.media__thumb[data-media-select="' + id + '"]'
      ).forEach(function (t) {
        t.style.setProperty('visibility', 'hidden', 'important');
        t.style.setProperty('opacity', '0', 'important');
        t.style.setProperty('pointer-events', 'none', 'important');
      });
    }
    document.addEventListener('int:gallery:settled', hideSentinelThumb);
    setTimeout(hideSentinelThumb, 1000);
    setTimeout(hideSentinelThumb, 4000);

    /* Re-hide after VIA rebuilds thumb strip — int:gallery:settled never fires
       when swatches.json 404s, so watch for DOM changes directly */
    (function() {
      var _sentinelRoot = document.querySelector('.media__thumb__wrapper, .media__thumb__holder');
      if (!_sentinelRoot || _sentinelRoot.__intSentinelObs) return;
      _sentinelRoot.__intSentinelObs = true;
      var _sentinelMo = new MutationObserver(function() {
        clearTimeout(_sentinelMo._t);
        _sentinelMo._t = setTimeout(hideSentinelThumb, 200);
      });
      _sentinelMo.observe(_sentinelRoot, { childList: true, subtree: true });
    })();

    /* Mark sentinel slide for CSS object-fit:contain targeting */
    function markSentinelSlide() {
      var id = window.__intVIASentinel;
      if (!id) return;
      var ss = document.querySelector('[data-product-slideshow]');
      if (!ss) return;
      var slide = ss.querySelector('[data-media-slide][data-media-id="' + id + '"]');
      if (slide) slide.classList.add('int-sentinel-slide');
    }
    document.addEventListener('int:gallery:settled', markSentinelSlide);
    setTimeout(markSentinelSlide, 4000);

    /* ══════════════════════════════════════════════════════════════════════
       VIEWPORT HEIGHT LOCK v15
    ══════════════════════════════════════════════════════════════════════ */
    function lockViewportHeight() {
      var slideshow = document.querySelector('.product__grid--slides');
      var vp        = slideshow && slideshow.querySelector('.flickity-viewport');
      var slider    = slideshow && slideshow.querySelector('.flickity-slider');
      if (!vp || !slideshow || !slider || vp.__intVpLocked) return;

      vp.__intVpLocked = true;
      var lockedH = vp.offsetHeight;
      var _sel = slideshow.querySelector('[data-media-slide].is-selected');
      var _selAR = _sel ? parseFloat(_sel.dataset.aspectRatio) : 0;
      var _vpW = vp.offsetWidth || slideshow.offsetWidth || 0;
      /* INT v23: AR-aware divergence gate — FRAMED PRINT ONLY. */
      if (document.body.classList.contains('int-frame-color-product')) {
        if (_selAR > 0 && _vpW > 50) {
          var _expectedH = Math.round(_vpW / _selAR);
          var _divergence = lockedH > 0 ? Math.abs(lockedH - _expectedH) / _expectedH : 1;
          if (!lockedH || _divergence > 0.08) {
            lockedH = _expectedH;
          }
        }
      } else {
        /* Original v22 behaviour — untouched for apparel etc. */
        if ((lockedH < 320 || !lockedH) && _selAR > 0 && _vpW > 50) {
          lockedH = Math.round(_vpW / _selAR);
        }
      }
      if (lockedH < 80) lockedH = parseInt(slideshow.dataset.intLastH || '0') || 450;
      slideshow.dataset.intLastH = lockedH;
      vp.style.height = lockedH + 'px';

      var assertMo = new MutationObserver(function() {
        if (!vp.__intVpLocked) { assertMo.disconnect(); return; }
        var cur = parseFloat(vp.style.height) || 0;
        if (Math.abs(cur - lockedH) > 10) vp.style.height = lockedH + 'px';
      });
      assertMo.observe(vp, { attributes: true, attributeFilter: ['style'] });

      var releaseTimer = null;
      var hardFallback = setTimeout(doRelease, 5000);

      function scheduleRelease() { clearTimeout(releaseTimer); releaseTimer = setTimeout(function() { clearTimeout(hardFallback); doRelease(); }, 600); }

      function doRelease() {
        if (!vp.__intVpLocked) return;
        vp.__intVpLocked = false; assertMo.disconnect(); sliderMo.disconnect();
        var sel      = slideshow.querySelector('[data-media-slide].is-selected');
        var naturalH = (sel && sel.offsetHeight > 50) ? sel.offsetHeight : lockedH;
        naturalH = Math.min(naturalH, slideshow.offsetHeight || naturalH);
        /* BUG5 fix: on mobile, clear vp height so CSS flow controls layout
           instead of locking in a desktop-calibrated px value */
        if (window.innerWidth < 768) {
          var _selMob = slideshow.querySelector('[data-media-slide].is-selected');
          var _mobW = vp.offsetWidth || slideshow.offsetWidth || window.innerWidth;
          var _mobAR = _selMob ? parseFloat(_selMob.dataset.aspectRatio) : 0;
          if (_mobAR > 0 && _mobW > 50) {
            var _mobH = Math.round(_mobW / _mobAR);
            vp.style.height = _mobH + 'px';
            slideshow.style.height = _mobH + 'px';
            slideshow.style.minHeight = _mobH + 'px';
            slideshow.style.paddingTop = '0';
          }
        } else {
          vp.style.height = naturalH + 'px';
        }
        slideshow.dataset.intLastH = naturalH;
        /* Thumb holder height controlled by CSS — do not override */
        /* INT v25: On framed print, skip the resize event dispatch.
           Per Claude Chrome diagnostic: this line was the source of the
           t=5701ms late oscillation (VP 311→306). Flickity responds to
           the resize by reading stale cell offsetHeight and producing
           a circular-read value. Apparel still needs the resize for its
           _intSetVPHeight to recalculate. */
        var _isFP = document.body.classList.contains('int-frame-color-product');
        requestAnimationFrame(function() {
          if (!_isFP) {
            window.dispatchEvent(new Event('resize'));
          }
          /* Single container-height fix, no cascade. Framed print handles
             its own height via Patch C v2 proto patch. */
          setTimeout(function() {
            if (typeof window.__intFixMobileContainerHeight === 'function') {
              window.__intFixMobileContainerHeight();
            }
          }, 300);
        });
        setTimeout(function() {
          var tw = document.querySelector('.media__thumb__wrapper');
          var th = document.querySelector('.media__thumb__holder');
          if (tw && tw.__intScrollToSuppressed) {
            tw.__intScrollToSuppressed = false;
            if (tw.__intOrigScrollTo !== undefined) { tw.scrollTo = tw.__intOrigScrollTo; delete tw.__intOrigScrollTo; }
            tw.scrollLeft = 0;
          }
          if (th) { th.scrollTop = 0; th.scrollLeft = 0; }
        }, 60);
      }

      var sliderMo = new MutationObserver(function() { scheduleRelease(); });
      sliderMo.observe(slider, { childList: true });
      if (window.__intCleanupRegistry) {
        window.__intCleanupRegistry.push(function() {
          clearTimeout(hardFallback);
          clearTimeout(releaseTimer);
          assertMo.disconnect();
          sliderMo.disconnect();
          vp.__intVpLocked = false;
        });
      }
      scheduleRelease();
    }

    /* ══════════════════════════════════════════════════════════════════════
       WRAPPER HEIGHT LOCK — StarApps opacity cycle
    ══════════════════════════════════════════════════════════════════════ */
    if (!window.__intHeightLockV10) {
      window.__intHeightLockV10 = true;
      function initHeightLock() {
        var wrapper = document.querySelector('.product__media__wrapper, .product_media__wrapper');
        if (!wrapper || wrapper.__intHeightObserved) return;
        wrapper.__intHeightObserved = true;
        var lockedH = null, releaseTimer = null;
        var mo = new MutationObserver(function() {
          var opacity = parseFloat(wrapper.style.opacity || '1');
          if (opacity < 0.01 && lockedH === null) {
            lockedH = wrapper.offsetHeight;
            wrapper.style.setProperty('min-height', lockedH + 'px', 'important');
            wrapper.style.setProperty('height', lockedH + 'px', 'important');
            wrapper.style.setProperty('overflow', 'hidden', 'important');
          } else if (opacity >= 0.99 && lockedH !== null) {
            clearTimeout(releaseTimer);
            releaseTimer = setTimeout(function() {
              function doRelease() { wrapper.style.removeProperty('min-height'); wrapper.style.removeProperty('height'); lockedH = null; }
              var selectedImg = wrapper.querySelector('[data-media-slide].is-selected img, [data-media-slide]:first-child img');
              if (selectedImg && !selectedImg.complete) {
                var fallback = setTimeout(doRelease, 900);
                selectedImg.addEventListener('load', function() { clearTimeout(fallback); doRelease(); }, { once: true });
                selectedImg.addEventListener('error', function() { clearTimeout(fallback); doRelease(); }, { once: true });
              } else { doRelease(); }
            }, 150);
          }
        });
        mo.observe(wrapper, { attributes: true, attributeFilter: ['style'] });
        if (window.__intCleanupRegistry) {
          window.__intCleanupRegistry.push(function() { mo.disconnect(); wrapper.__intHeightObserved = false; lockedH = null; });
        }
      }
      initHeightLock(); document.addEventListener('DOMContentLoaded', initHeightLock); setTimeout(initHeightLock, 2000);
    }

    /* ── rAF scroll guard ─────────────────────────────────────────────── */
    if (!window.__intSwatchGuardV9) {
      window.__intSwatchGuardV9 = true;
      var guardY = null, guardEnd = 0, guardRaf = null, touchStartY = -1;
      var _scrollTo = window.scrollTo.bind(window), _scroll = window.scroll.bind(window);
      var _scrollBy = window.scrollBy ? window.scrollBy.bind(window) : null;
      window.scrollTo = function() { if (guardY !== null) return; return _scrollTo.apply(this, arguments); };
      window.scroll   = function() { if (guardY !== null) return; return _scroll.apply(this, arguments); };
      if (_scrollBy) window.scrollBy = function() { if (guardY !== null) return; return _scrollBy.apply(this, arguments); };
      if (!Element.prototype.__origSIV) {
        Element.prototype.__origSIV = Element.prototype.scrollIntoView;
        Element.prototype.scrollIntoView = function(arg) { if (guardY !== null) return; return Element.prototype.__origSIV.call(this, arg); };
      }
      if (!Element.prototype.__origFocus2) {
        Element.prototype.__origFocus2 = Element.prototype.focus;
        Element.prototype.focus = function(opts) { return Element.prototype.__origFocus2.call(this, Object.assign({}, opts || {}, { preventScroll: true })); };
      }
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      /* INT 2026-06: event-driven scroll guard. The old rAF guardTick ran every
         frame for 1400ms reading window.pageYOffset, and during VIA's gallery
         rebuild that read forced a synchronous layout each frame, so it cost far
         more than its own time. The window.scrollTo / scroll / scrollBy /
         scrollIntoView / focus overrides above already block the programmatic
         scroll sources, so the only remaining job is to correct a native scroll
         if one slips through. A passive scroll listener reads pageYOffset only
         after the browser has already laid out for the scroll, so it never
         forces reflow. */
      var _guardEndTimer = null, _userScrolled = false;
      function onGuardScroll() {
        /* INT 2026-08-30, revised the same day after Nils tested it on his phone.
           FIRST attempt ended the whole guard on a scroll gesture. That was wrong:
           clearing guardY also releases the scrollTo / scroll / scrollBy /
           scrollIntoView / focus overrides, so the theme's own jumps fired again
           the moment a finger touched the screen, and the page still misbehaved.
           Correct split: guardY STAYS SET for the whole window, so every
           PROGRAMMATIC jump is still blocked — that is the job the guard exists
           for. Only this native snap-back stands down, and only once the visitor
           has actually made a scroll gesture. Before the fix the page ignored the
           finger for 1,113 to 1,376 ms after a colour tap. */
        if (_userScrolled) return;
        if (guardY !== null && Math.abs(window.pageYOffset - guardY) > 5) _scrollTo({ top: guardY, behavior: 'instant' });
      }
      function endGuard() { guardY = null; _userScrolled = false; window.removeEventListener('scroll', onGuardScroll); }
      function _userTookOver() { _userScrolled = true; }
      document.addEventListener('touchmove', _userTookOver, { passive: true, capture: true });
      document.addEventListener('wheel',     _userTookOver, { passive: true, capture: true });
      document.addEventListener('keydown', function (e) {
        if (/^(Arrow|Page|Home|End| )/.test(e.key || '')) _userTookOver();
      }, { passive: true, capture: true });
      function startGuard(y) {
        guardY = y; guardEnd = Date.now() + 1400;
        window.addEventListener('scroll', onGuardScroll, { passive: true });
        clearTimeout(_guardEndTimer);
        _guardEndTimer = setTimeout(endGuard, 1400);
      }
      function extendGuard() { if (guardY !== null) { guardEnd = Date.now() + 1000; clearTimeout(_guardEndTimer); _guardEndTimer = setTimeout(endGuard, 1000); } }
      document.addEventListener('touchstart', function(e) { var t = e.target; if (t && t.closest && t.closest('.int-gswatch, .swatch__button, [data-swatch], label[data-value]')) touchStartY = window.pageYOffset; }, { passive: true, capture: true });
      document.addEventListener('touchend', function(e) { var t = e.target; if (t && t.closest && t.closest('.int-gswatch, .swatch__button, [data-swatch], label[data-value]')) { startGuard(touchStartY >= 0 ? touchStartY : window.pageYOffset); touchStartY = -1; } }, { passive: true, capture: true });
      document.addEventListener('click', function(e) { var t = e.target; if (t && t.closest && t.closest('.int-gswatch, .swatch__button, [data-swatch], label[data-value]')) { if (guardY === null) startGuard(window.pageYOffset); } }, true);
      document.addEventListener('variant:change', function() { extendGuard(); }, true);
      /* Removed 2026-08-14: a global XMLHttpRequest.prototype.open override
         whose only job was to extend the scroll guard when a StarApps request
         finished. The app is gone, so it patched every XHR on the page and
         never fired. */
    }

    /* ── Swatch click handler ─────────────────────────────────────────── */
    document.querySelectorAll('.int-gswatch').forEach(function(btn) {
      btn.addEventListener('click', function() {

        var _ss = document.querySelector('.product__grid--slides');
        var _sl = _ss && _ss.querySelector('.flickity-slider');

        /* Lock 1: current selected slide.
           INT 2026-06: on apparel desktop the int-swatch-hold overlay is the
           mask: a clone parented to the stable slideshow that survives VIA's
           rebuild and repaints to the new hero on decode. int-slide-locked is a
           second, redundant mask that holds the OUTGOING slide visible and
           releases ~150ms later than the overlay (a 250ms settle after the new
           hero is selected), so once the overlay lifts the still-locked outgoing
           slide shows through for that gap, which is the old image flashing back
           and the new one landing late. Keep int-slide-locked on mobile (no
           overlay there) and on frame-color products (overlay is apparel-only),
           and let the overlay be the sole mask on apparel desktop. */
        var _cur = (window.innerWidth < 768 || document.body.classList.contains('int-frame-color-product'))
          && _ss && _ss.querySelector('[data-media-slide].is-selected');
        if (_cur) {
          _cur.classList.add('int-slide-locked');
          var _curDone = false;
          /* Bug A2 fix: shorter fallback. MO releases the lock as soon as a
             different slide gains is-selected (typical 50-150ms). The fallback
             only matters when MO never fires (VIA stalls or replaces the slide
             element wholesale rather than toggling is-selected). Capped at
             400ms instead of 1000ms — eliminates the worst-case "old hero
             held visible for a second" symptom. The post-MO 1200ms image-decode
             wait below is left intact, so first-paint of the new hero is still
             protected against undecoded-image blank frames. */
          var _curFb = setTimeout(function() { if (_cur && _cur.parentNode) _cur.classList.remove('int-slide-locked'); }, 400);
          if (_ss) {
            /* Bug A3 fix: debounce the MO release. Multi-variant products
               (hoodies, others with longer cell-list rebuilds) briefly land
               Flickity on a wrong cell during VIA's rebuild before
               correcting (~59ms gap per Phase 7 diagnostic). The previous
               MO released the lock on the FIRST is-selected change to any
               different slide — which could be the wrong-cell transient,
               exposing it as a flash. This version waits a 150ms settle
               window after the last is-selected change before releasing.
               If another change happens within the window (i.e. the
               wrong→right correction), the timer resets and the lock
               holds through it. Adds ~150ms to the cross-fade tail on
               clean transitions (t-shirt path) — outgoing slide stays
               correctly locked during that window, so no visible
               regression. */
            var _settleTimer = null;
            var _lastSelTarget = null;
            var _moFiredOnce = false;
            function _doRelease(_t) {
              if (_curDone) return;
              _curDone = true; _curMo.disconnect();
              var _newImg = _t.querySelector('img');
              var _needsUpgrade = _newImg && _newImg.dataset.fpSrc && !_newImg.dataset.fpUpgraded;
              var _isReady = _newImg && _newImg.naturalWidth > 100;
              if (_needsUpgrade || !_isReady) {
                if (_needsUpgrade) {
                  _newImg.dataset.fpUpgraded = '1';
                  _newImg.loading = 'eager';
                  if (_newImg.dataset.fpSrcset) _newImg.srcset = _newImg.dataset.fpSrcset;
                  _newImg.src = _newImg.dataset.fpSrc;
                  _newImg.sizes = '(min-width: 1100px) 70vw, (min-width: 768px) 50vw, 85vw';
                }
                var _unlockFb = setTimeout(function() {
                  clearInterval(_pollReady);
                  if (_cur && _cur.parentNode) _cur.classList.remove('int-slide-locked');
                }, 1200);
                /* INT 2026-08: check once synchronously before arming the
                   interval, and poll per frame instead of every 50ms. An
                   image that was already decoded used to sit through a full
                   50ms tick waiting for a check that would have passed
                   straight away. On the synchronous call _pollReady is still
                   null and clearInterval(null) is a no-op, so that path is
                   safe; _unlockFb is already assigned above, so clearing it
                   early is safe too. */
                var _checkReady = function() {
                  if (!(_newImg.naturalWidth > 100)) return false;
                  clearInterval(_pollReady);
                  clearTimeout(_unlockFb);
                  if (_cur && _cur.parentNode) _cur.classList.remove('int-slide-locked');
                  return true;
                };
                var _pollReady = null;
                if (!_checkReady()) _pollReady = setInterval(_checkReady, 16);
              } else {
                if (_cur && _cur.parentNode) _cur.classList.remove('int-slide-locked');
              }
            }
            var _curMo = new MutationObserver(function(muts) {
              if (_curDone) return;
              for (var _mi = 0; _mi < muts.length; _mi++) {
                var _t = muts[_mi].target;
                if (_t !== _cur && _t.classList && _t.classList.contains('is-selected')) {
                  /* First MO fire — cancel the "MO never fires" fallback.
                     From here on, the settle timer governs release. A
                     safety hard-cap at 800ms below catches pathological
                     churn (is-selected ping-ponging beyond a reasonable
                     window). */
                  if (!_moFiredOnce) {
                    _moFiredOnce = true;
                    clearTimeout(_curFb);
                    setTimeout(function() {
                      if (_curDone || !_lastSelTarget) return;
                      _doRelease(_lastSelTarget);
                    }, 800);
                  }
                  _lastSelTarget = _t;
                  clearTimeout(_settleTimer);
                  _settleTimer = setTimeout(function() {
                    if (_curDone || !_lastSelTarget) return;
                    /* Verify last-seen target is still is-selected — if
                       it lost is-selected during the settle window, the
                       transition is mid-flux and we should wait for the
                       next mutation rather than releasing. */
                    if (!_lastSelTarget.classList.contains('is-selected')) return;
                    _doRelease(_lastSelTarget);
                  }, 150);
                  break; /* one mutation per batch — debounce handles further */
                }
              }
            });
            _curMo.observe(_ss, { attributes: true, attributeFilter: ['class'], subtree: true });
          }
        }

        /* Lock 2: sentinel slide — use dynamic ID, but skip if it's the
           currently-selected slide. Bug A1 fix: defense-in-depth alongside
           the CSS :not(.is-selected) guard. Prevents the blank flash when
           __intVIASentinel coincides with the active variant's hero. */
        var _sentinelId = window.__intVIASentinel || '62237083173128';
        var _snt = _ss && _ss.querySelector('[data-media-id="' + _sentinelId + '"]');
        if (_snt && !_snt.classList.contains('is-selected')) {
          _snt.classList.add('int-sentinel-locked');
          var _sntFb = setTimeout(function() { if (_snt && _snt.parentNode) _snt.classList.remove('int-sentinel-locked'); }, 1200);
          if (_sl) {
            var _sntMo = new MutationObserver(function() { clearTimeout(_sntFb); _sntMo.disconnect(); });
            _sntMo.observe(_sl, { childList: true });
          }
        }

        /* Suppress thumb strip scroll during VIA cycle */
        var _tw = document.querySelector('.media__thumb__wrapper');
        if (_tw && !_tw.__intScrollToSuppressed) {
          _tw.__intScrollToSuppressed = true;
          _tw.__intOrigScrollTo = _tw.scrollTo;
          _tw.scrollTo = function() { /* suppressed */ };
        }

        /* INT 2026-07: thumb-rail lock. On a colour change VIA rebuilds the
           thumb rail from the server-rendered default state (the FIRST
           colour's thumb set) before filtering to the new colour, and the
           dead-thumb hider only reacts ~200ms after the rebuild (its poll
           loop is initial-load-only) — that gap is the "first colour's
           thumbnails flash" on every swatch click. Mask the rail
           (visibility keeps layout height, so nothing below shifts) and
           reveal only after the rail has been stable for 250ms, re-running
           the dead-thumb hider first so wrong-colour thumbs are already
           display:none when the mask lifts. Hard cap 1500ms. */
        (function() {
          var _twl = document.querySelector('.media__thumb__wrapper, .media__thumb__holder');
          if (!_twl || _twl.__intThumbsLockActive) return;
          _twl.__intThumbsLockActive = true;
          var _twlHost = _twl.parentNode || _twl;
          _twl.classList.add('int-thumbs-locked');
          var _twlDone = false, _twlMo = null, _twlTimer = null;
          var _twlRelease = function() {
            if (_twlDone) return;
            _twlDone = true;
            clearTimeout(_twlTimer);
            if (_twlMo) _twlMo.disconnect();
            if (typeof window.__intHideDeadThumbs === 'function') window.__intHideDeadThumbs();
            var _twNow = document.querySelector('.media__thumb__wrapper, .media__thumb__holder');
            [_twl, _twNow].forEach(function(n) {
              if (!n) return;
              n.classList.remove('int-thumbs-locked');
              n.__intThumbsLockActive = false;
            });
            /* INT 2026-07c: recalc the big-image viewport height for the
               NEW colour's hero. The swatch transition holds the OUTGOING
               colour's height, and the select handler can skip the recalc
               when the new hero lands on the same slide index — a taller
               hero then renders bottom-cropped until the next thumb click.
               By this point the rail has settled and the hero is decoded,
               so recalc from its natural dimensions. */
            if (typeof window.__intSetVPHeight === 'function') {
              requestAnimationFrame(function() { window.__intSetVPHeight(); });
            }
          };
          _twlTimer = setTimeout(_twlRelease, 450);
          _twlMo = new MutationObserver(function() {
            /* VIA may replace the wrapper element wholesale — re-stamp the
               mask class onto whichever wrapper is current */
            var _twNow = document.querySelector('.media__thumb__wrapper, .media__thumb__holder');
            if (_twNow && !_twNow.classList.contains('int-thumbs-locked')) _twNow.classList.add('int-thumbs-locked');
            clearTimeout(_twlTimer);
            _twlTimer = setTimeout(_twlRelease, 250);
          });
          _twlMo.observe(_twlHost, { childList: true, subtree: true });
          setTimeout(_twlRelease, 1500);
        })();

        if (window.innerWidth < 768 && _ss) {
          var _preVp = _ss.querySelector('.flickity-viewport');
          var _preSel = _ss.querySelector('[data-media-slide].is-selected');
          if (_preVp && _preSel) {
            /* INT v20: use cached container-AR cap height AND re-assert
               during the swatch transition window. Flickity's internal
               setGallerySize reads the OLD selected slide's height at
               ~63ms post-click and writes fractional sub-pixel values
               (e.g. 362.281px) to vp, overriding our pre-stamp. We
               observe vp style mutations for 1100ms and re-stamp the
               capped value if it drifts. Eliminates the mobile thumb
               row shift. */
            var _preVpW = _preVp.offsetWidth || _ss.offsetWidth || window.innerWidth;
            var _preAR = (typeof window.__intGetContainerAR === 'function')
              ? window.__intGetContainerAR(_ss) : 0;
            if (!_preAR) _preAR = parseFloat(_preSel.dataset.aspectRatio) || 0;
            var _preH = _preAR > 0 ? Math.round(_preVpW / _preAR) : _preSel.offsetHeight;
            if (_preH > 80) {
              _preVp.style.height = _preH + 'px';
              _ss.style.height = _preH + 'px';
              _ss.style.minHeight = _preH + 'px';

              /* Lock vp to capped height for the transition window.
                 Any write that drifts > 1px from _preH gets re-asserted.
                 Auto-disconnects after 1100ms (longer than the ~815ms
                 observed drift window). */
              if (!_preVp.__intSwatchLocking) {
                _preVp.__intSwatchLocking = true;
                var _lockMo = new MutationObserver(function() {
                  var _curH = parseFloat(_preVp.style.height) || 0;
                  if (Math.abs(_curH - _preH) > 1) {
                    _preVp.style.height = _preH + 'px';
                  }
                });
                _lockMo.observe(_preVp, { attributes: true, attributeFilter: ['style'] });
                setTimeout(function() {
                  _lockMo.disconnect();
                  _preVp.__intSwatchLocking = false;
                }, 1100);
              }
            }
          }
        }
        if (window.__intFPLazyInit) lockViewportHeight();

        var variantId = btn.dataset.variantId;
        var colorVal  = btn.dataset.value;
        if (!variantId) return;

        try {
          var _pf = document.querySelector('product-form');
          var _idIn = (_pf || document).querySelector('input[name="id"]');
          var currentId = (_idIn && _idIn.value)
            || new URLSearchParams(window.location.search).get('variant')
            || window.__intDefaultVariantId;

          /* ════════════════════════════════════════════════════════════════
             🚨 NEVER SPLIT public_title ON ' / ' TO FIND THE TARGET VARIANT.

             This used to do exactly that, and on framed print an option VALUE
             contains that separator itself: "13x18 cm / 5x7″". So a three
             option product split into FOUR parts, parts[COLOR_POS] landed on
             "5x7″" instead of the colour, the rebuilt title matched no variant,
             and variantId silently stayed the swatch's REPRESENTATIVE variant,
             which is the first frame size.

             Measured live 2026-09-03 on abundance-wood-frame-with-matte-paper by
             running both algorithms over every combination: the split failed on
             224 of 320 (variant × colour) pairs, 70% of them. On apparel, where
             no option value contains ' / ', the two agree on all 200 pairs, so
             the array route below is a drop in there.

             ⚑ WHAT THE WRONG ID DID, and it is Nils's "pressing colour swatches
             is very slow, it turns all white": the wrong id was written into the
             URL by the replaceState further down, and it was the variant carried
             by the 'variant:change' event dispatched further down, so every
             listener, the gallery included, swapped to a 13x18 image that had
             never been downloaded and the slide sat empty until it arrived. A
             setTimeout(…, 0) safety net put the URL right about 300ms later,
             which is why it read as slowness rather than as a wrong lookup.
             The form input was never wrong, so nothing could be added to the
             cart at the wrong price.

             ⚑ OPTION VALUES ARE AN ARRAY, in the theme's [data-product-json].
             Compare arrays, never a joined string. window.meta.product.variants
             carries only {id, price, name, public_title, sku} and has no
             options, which is why the old code reached for the string at all.
             ════════════════════════════════════════════════════════════════ */
          if (window.__intGSProductJson === undefined) {
            window.__intGSProductJson = null;
            var _pjEl = document.querySelector('[data-product-json]');
            if (_pjEl) { try { window.__intGSProductJson = JSON.parse(_pjEl.textContent); } catch (e) {} }
          }
          var _pj = window.__intGSProductJson;
          var _matched = false;
          if (_pj && _pj.variants && COLOR_POS >= 0) {
            var _pv = _pj.variants, _cur = null, _i, _k;
            for (_i = 0; _i < _pv.length; _i++) { if (String(_pv[_i].id) === String(currentId)) { _cur = _pv[_i]; break; } }
            if (_cur && _cur.options && COLOR_POS < _cur.options.length) {
              var _want = _cur.options.slice();
              _want[COLOR_POS] = colorVal;
              for (_i = 0; _i < _pv.length; _i++) {
                var _o = _pv[_i].options;
                if (!_o || _o.length !== _want.length) continue;
                var _same = true;
                for (_k = 0; _k < _want.length; _k++) { if (_o[_k] !== _want[_k]) { _same = false; break; } }
                if (_same) { variantId = String(_pv[_i].id); _matched = true; break; }
              }
            }
          }

          /* Fallback, only for a page with no [data-product-json]. It is the old
             string route, and it is now GUARDED: it is trusted only when the
             split produces exactly as many parts as the product has option
             selectors on screen. That is the condition the old code assumed and
             never checked, and checking it is what would have caught this.
             INT 2026-08-17, kept because it is still true: COLOR_POS must be the
             real colour index, not parts.length - 1. On apparel Colour is option
             1 and Size is last, and assuming last produced
             "Burgundy / French Navy", which matched nothing. */
          if (!_matched && window.meta && window.meta.product && window.meta.product.variants) {
            var _optCount = document.querySelectorAll('.selector-wrapper[data-select-label]').length;
            var currentVariant = null;
            var variants = window.meta.product.variants;
            for (var vi = 0; vi < variants.length; vi++) { if (String(variants[vi].id) === String(currentId)) { currentVariant = variants[vi]; break; } }
            if (currentVariant && currentVariant.public_title) {
              var parts = currentVariant.public_title.split(' / ');
              if (COLOR_POS >= 0 && COLOR_POS < parts.length && (_optCount === 0 || parts.length === _optCount)) {
                parts[COLOR_POS] = colorVal;
                var targetTitle = parts.join(' / ');
                for (var vi2 = 0; vi2 < variants.length; vi2++) { if (variants[vi2].public_title === targetTitle) { variantId = String(variants[vi2].id); break; } }
              }
            }
          }
        } catch(e) { console.warn('[INT swatches] variant match error:', e); }

        document.querySelectorAll('.int-gswatch').forEach(function(b) { b.classList.remove('int-gswatch--active'); });
        btn.classList.add('int-gswatch--active');
        /* 2026-10-26 colour-display-names: show the translated colour name (the
           button's title, from snippets/int-colour-names.liquid); colorVal stays the
           English option value that every match below needs. */
        actName = btn.getAttribute('title') || colorVal;
        if (nameEl) nameEl.textContent = actName;

        var triggered = false;
        document.querySelectorAll('select.single-option-selector').forEach(function(sel, i) { if (triggered || i !== COLOR_POS) return; sel.value = colorVal; sel.dispatchEvent(new Event('change', { bubbles: true })); triggered = true; });
        if (!triggered) { var sel = document.querySelector('select[data-option-index="' + COLOR_POS + '"]'); if (sel) { sel.value = colorVal; sel.dispatchEvent(new Event('change', { bubbles: true })); triggered = true; } }
        if (!triggered) { var sel2 = document.querySelector('.selector-wrapper--color select, .selector-wrapper--colour select, .selector-wrapper--frame-color select'); if (sel2) { sel2.value = colorVal; sel2.dispatchEvent(new Event('change', { bubbles: true })); triggered = true; } }
        if (!triggered) {
          window.__intSwatchTapping = true;
          document.querySelectorAll('input[type="radio"]').forEach(function(r) {
            if (triggered) return;
            if (r.value === colorVal || r.value.toLowerCase() === colorVal.toLowerCase()) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); r.dispatchEvent(new Event('click', { bubbles: true })); triggered = true; }
          });
          setTimeout(function() { window.__intSwatchTapping = false; }, 600);
        }

        /* Eager-load the target variant's first slide. INT 2026-06: deferred to
           the next animation frame so it no longer runs inside the click task.
           This block builds Image objects and calls decode() over the target and
           adjacent slides; the native variant change has already been triggered
           above, so warming the cache one frame later still lands well before
           Flickity paints the new hero, while letting the click task return so
           the browser can paint instead of blocking here. */
        requestAnimationFrame(function() {
          var _ss = document.querySelector('[data-product-slideshow]');
          var _Flk = window.themeVendor && window.themeVendor.Flickity;
          var _f = _ss && _Flk && _Flk.data(_ss);
          if (!_f || !window.meta || !window.meta.product) return;
          try {
            var _targetVariant = null;
            (window.meta.product.variants || []).forEach(function(v) {
              if (String(v.id) === String(variantId)) _targetVariant = v;
            });
            if (!_targetVariant || !_targetVariant.featured_media) {
              /* BUG3/4 fix: featured_media is null on FP variants — upgrade all
                 lazy slides from __intFPMediaMap so images are cached before
                 Flickity navigates, eliminating blank-then-appear flash */
              if (window.__intFPMediaMap) {
                _ss.querySelectorAll('[data-media-slide] img[data-fp-src]').forEach(function(_fpImg) {
                  if (_fpImg.dataset.fpUpgraded === '1') return;
                  _fpImg.dataset.fpUpgraded = '1';
                  _fpImg.loading = 'eager';
                  if (_fpImg.dataset.fpSrcset) _fpImg.srcset = _fpImg.dataset.fpSrcset;
                  _fpImg.src = _fpImg.dataset.fpSrc;
                  _fpImg.sizes = '(min-width: 1100px) 70vw, (min-width: 768px) 50vw, 85vw';
                  if (typeof _fpImg.decode === 'function') _fpImg.decode().catch(function(){});
                });
              }
              return;
            }
            var _targetMediaId = String(_targetVariant.featured_media.id);
            var _slides = Array.from(_ss.querySelectorAll('[data-media-slide]'));
            var _targetIdx = -1;
            _slides.forEach(function(s, i) {
              if (String(s.dataset.mediaId) === _targetMediaId) _targetIdx = i;
            });
            if (_targetIdx < 0) return;
            /* INT v21: Prefetch target + adjacent slides. decode() alone
               doesn't guarantee the network fetch completes before Flickity
               navigates to the slide — on swatch clicks that switch to a
               not-yet-cached variant hero, user saw a ~93ms progressive
               decode "reveal" as image bytes arrived.
               Fix: (1) set loading=eager so Flickity doesn't skip the img,
                    (2) force a real network fetch via a detached Image object
                        that populates the HTTP cache eagerly,
                    (3) when img is ready (cached or loaded), call decode()
                        to warm the GPU texture before Flickity paints. */
            [_targetIdx, _targetIdx + 1].forEach(function(idx) {
              var _slide = _slides[idx];
              if (!_slide) return;
              var _img = _slide.querySelector('img');
              if (!_img || !_img.src) return;
              _img.loading = 'eager';

              /* Force network fetch via detached Image. Browser will reuse
                 the HTTP cache when Flickity later renders the real img. */
              var _warm = new Image();
              if (_img.srcset) _warm.srcset = _img.srcset;
              if (_img.sizes) _warm.sizes = _img.sizes;
              _warm.src = _img.src;
              _warm.decoding = 'async';
              if (typeof _warm.decode === 'function') {
                _warm.decode().then(function() {
                  /* Once cached, also warm the real img's GPU texture */
                  if (_img.decode) _img.decode().catch(function(){});
                }).catch(function(){});
              }
            });
          } catch(e) {}
        });

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        history.replaceState({}, '', url.toString());
        /* INT 2026-08-17: final safety - the URL must agree with the form. */
        setTimeout(function() {
          var _sf = document.querySelector('product-form');
          var _si = _sf && _sf.querySelector('input[name="id"]');
          if (!_si || !_si.value) return;
          var _su = new URL(window.location.href);
          if (_su.searchParams.get('variant') === String(_si.value)) return;
          _su.searchParams.set('variant', _si.value);
          history.replaceState({}, '', _su.toString());
        }, 0);
        var variantObj = null;
        if (window.meta && window.meta.product && window.meta.product.variants) {
          window.meta.product.variants.forEach(function(v) { if (String(v.id) === String(variantId)) variantObj = v; });
        }
        if (variantObj) {
          var evt = new CustomEvent('variant:change', { bubbles: true, detail: { variant: variantObj } });
          document.dispatchEvent(evt);
          var ps = document.querySelector('[data-section-type="product"]');
          if (ps) ps.dispatchEvent(evt);
        }

        if (!triggered) {
          console.warn('[INT swatches] no trigger found.');
          document.querySelectorAll('select').forEach(function(s, i) { console.warn('  [' + i + ']', s.id, s.className); });
        }
      });
    });

    /* ══════════════════════════════════════════════════════════════════════
       VIA / SA-PATCH GALLERY REPAIR v14

       v12/v13 were dead code. The MO setup ran at inline-script parse
       time, before theme.js defer + customElements upgrade had created
       the .flickity-slider and .flickity-viewport elements. Both
       querySelectors returned null. The MOs were never attached.
       runRepair was never called.

       Diagnostic confirmed: post-15s captures show selectedIndex=-1,
       selectedCell.element detached, six DOM slides for the active
       variant present but none with is-selected, and post-swatch-click
       state byte-identical to initial-load state. The v13 recovery
       branch never executed because nothing ever invoked runRepair.

       v14:
       - Poll for Flickity elements before attaching MOs (mirrors the
         _pollApparel pattern already used in this file).
       - Add direct triggers: int:gallery:settled, variant:change, plus
         safety timeouts at multiple points in the first 18 seconds.
       - Robust runRepair: prefers the active variant's featured_media
         from window.meta, falls back to first attached cell, falls
         back to direct DOM is-selected stamp if Flickity rejects.
    ══════════════════════════════════════════════════════════════════════ */
    if (!window.__intGalleryRepairV11) {
      window.__intGalleryRepairV11 = true;

      function _intFindVariantHeroIdx(ss) {
        var map = window.__intVariantHeroMap;
        if (!map) return -1;
        var params = new URLSearchParams(window.location.search);
        var vid = params.get('variant') || window.__intDefaultVariantId;
        if (!vid) return -1;
        var heroId = map[String(vid)];
        if (!heroId) return -1;
        heroId = String(heroId);
        var slides = ss.querySelectorAll('[data-media-slide]');
        for (var j = 0; j < slides.length; j++) {
          if (String(slides[j].dataset.mediaId) === heroId) return j;
        }
        return -1;
      }

      function _intFindAttachedCellIdx(flkty) {
        if (!flkty || !flkty.cells) return -1;
        for (var i = 0; i < flkty.cells.length; i++) {
          var el = flkty.cells[i].element;
          if (el && document.contains(el)) return i;
        }
        return -1;
      }

      function runRepair() {
        var ss = document.querySelector('[data-product-slideshow]');
        if (!ss) return;
        var vp = ss.querySelector('.flickity-viewport');
        if (vp && vp.__intVpLocked) return;
        var sel = ss.querySelector('[data-media-slide].is-selected');

        if (sel) {
          /* Healthy state, true no-op. The previous height nudge and
             resize dispatch fired on every safety-timeout tick and
             caused a visible re-layout flicker on desktop at ~2500 ms
             (Claude Chrome diagnostic 2026-05-28). Height management is
             owned by _intSetVPHeight (apparel) and the setGallerySize
             proto patch (framed print); an unconditional nudge here is
             redundant with both. */
          return;
        }

        /* Broken state. No slide has is-selected. Cascade through recovery. */
        var _Flk = window.Flickity || (window.themeVendor && window.themeVendor.Flickity);
        var flkty = _Flk && _Flk.data && _Flk.data(ss);

        var targetIdx = _intFindVariantHeroIdx(ss);
        if (targetIdx < 0 && flkty) targetIdx = _intFindAttachedCellIdx(flkty);
        if (targetIdx < 0) {
          var slides = ss.querySelectorAll('[data-media-slide]');
          if (!slides.length) return;
          targetIdx = 0;
        }

        /* Path 1: Flickity API. */
        if (flkty && flkty.cells && targetIdx < flkty.cells.length) {
          try {
            flkty.select(targetIdx, false, true);
            if (ss.querySelector('[data-media-slide].is-selected')) return;
          } catch (e) {}
          /* Path 2: reloadCells then select. */
          try {
            if (typeof flkty.reloadCells === 'function') {
              flkty.reloadCells();
              flkty.select(targetIdx, false, true);
              if (ss.querySelector('[data-media-slide].is-selected')) return;
            }
          } catch (e) {}
        }

        /* Path 3: direct DOM stamp. Bypasses Flickity entirely. */
        var allSlides = ss.querySelectorAll('[data-media-slide]');
        allSlides.forEach(function(s, i) {
          if (i === targetIdx) {
            s.classList.add('is-selected');
          } else {
            s.classList.remove('is-selected');
          }
        });
      }

      function _intRepairAttachMOs() {
        var sliderEl = document.querySelector('.product__grid--slides .flickity-slider');
        var vpEl = document.querySelector('.product__grid--slides .flickity-viewport');
        var slideshow = document.querySelector('.product__grid--slides');
        if (!sliderEl || !vpEl || !slideshow) return false;
        if (sliderEl.__intRepairAttached) return true;
        sliderEl.__intRepairAttached = true;

        var repairDebounce = null;
        var lastChildCount = sliderEl.children.length;
        /* INT v14d: mask the WHOLE initial-load VIA rebuild storm, not just
           the first pass. VIA rebuilds the cell list several times in quick
           succession on cold load; v14c cloaked only the first pass and
           lifted ~120ms after it, so any later pass ran uncloaked and the
           hero blanked for a frame each time. Now we cloak on every
           child-count change while the load window is open, and lift once
           when VIA settles (or a 3.5s safety, or the first user
           interaction). The cloak is scoped by :has(img[fetchpriority="high"])
           so the LCP hero stays painted the whole time; only the non-LCP
           slides sit at opacity 0, which is the correct cold-load view. The
           window closes on first pointerdown so a swatch click is never
           cloaked, since int-slide-locked owns that transition. */
        var _intLoadCloakOpen = true;
        /* INT v14e: during the cloak window, also hold the cached hero as the
           flickity-viewport background. The cloak pins the LCP slide via
           :has(img[fetchpriority="high"]), but VIA swaps the hero img mid
           rebuild and drops that attribute, so for ~160ms no slide carries
           is-selected or fetchpriority and the hero blanks once. Painting the
           last-good hero on the viewport, a stable element VIA does not touch,
           masks that gap with cached pixels and no dependency on cell state. */
        var _intCloakHeroSrc = null, _intCloakVp = null;
        function _intCloakCacheHero() {
          var _s = slideshow.querySelector('[data-media-slide].is-selected');
          var _i = (_s && _s.querySelector('img')) || slideshow.querySelector('img[fetchpriority="high"]');
          if (_i && _i.currentSrc && _i.naturalWidth > 0) _intCloakHeroSrc = _i.currentSrc;
        }
        function _intCloakPaint() {
          if (!_intCloakHeroSrc) return;
          var _vp = slideshow.querySelector('.flickity-viewport');
          if (!_vp) return;
          _vp.style.setProperty('background-image', 'url("' + _intCloakHeroSrc + '")', 'important');
          _vp.style.setProperty('background-size', 'contain', 'important');
          _vp.style.setProperty('background-position', 'center', 'important');
          _vp.style.setProperty('background-repeat', 'no-repeat', 'important');
          _intCloakVp = _vp;
        }
        function _intCloakClear() {
          if (!_intCloakVp) return;
          _intCloakVp.style.removeProperty('background-image');
          _intCloakVp.style.removeProperty('background-size');
          _intCloakVp.style.removeProperty('background-position');
          _intCloakVp.style.removeProperty('background-repeat');
          _intCloakVp = null;
        }
        _intCloakCacheHero();
        function _intLiftLoadCloak() {
          _intLoadCloakOpen = false;
          slideshow.classList.remove('int-via-rebuilding');
          _intCloakClear();
        }
        document.addEventListener('int:gallery:settled', _intLiftLoadCloak, { once: true });
        document.addEventListener('pointerdown', _intLiftLoadCloak, { capture: true, once: true });
        setTimeout(_intLiftLoadCloak, 3500);
        var _repairSliderMo = new MutationObserver(function() {
          var n = sliderEl.children.length;
          if (n !== lastChildCount) {
            lastChildCount = n;
            if (_intLoadCloakOpen) {
              _intCloakCacheHero();
              slideshow.classList.add('int-via-rebuilding');
              _intCloakPaint();
            }
            clearTimeout(repairDebounce);
            repairDebounce = setTimeout(runRepair, 120);
          }
        });
        _repairSliderMo.observe(sliderEl, { childList: true });

        var lastGoodH = vpEl.offsetHeight;
        var _repairVpMo = new MutationObserver(function() {
          setTimeout(function() {
            if (vpEl.__intVpLocked) return;
            var h = vpEl.offsetHeight;
            if (h < 10 && lastGoodH > 50) { runRepair(); return; }
            if (h > 10) lastGoodH = h;
          }, 0);
        });
        _repairVpMo.observe(vpEl, { attributes: true, attributeFilter: ['style'] });

        if (window.__intCleanupRegistry) {
          window.__intCleanupRegistry.push(function() {
            _repairSliderMo.disconnect();
            _repairVpMo.disconnect();
          });
        }
        return true;
      }

      (function _pollMOAttach() {
        if (_intRepairAttachMOs()) return;
        if (Date.now() - (_pollMOAttach._start || (_pollMOAttach._start = Date.now())) < 20000) {
          setTimeout(_pollMOAttach, 500);
        }
      })();

      document.addEventListener('int:gallery:settled', function() { setTimeout(runRepair, 50); });

      [2500, 5000, 8000, 13000, 18000].forEach(function(ms) {
        setTimeout(runRepair, ms);
      });

      document.addEventListener('variant:change', function() {
        setTimeout(runRepair, 500);
        setTimeout(runRepair, 1500);
        setTimeout(runRepair, 3500);
      });
    }

    /* BUG1 mobile: fix 600px inline style at init — framed prints only */
    if (window.__intFPLazyInit && window.innerWidth < 768) {
      setTimeout(function() {
        if (typeof window.__intFixMobileContainerHeight === 'function') {
          window.__intFixMobileContainerHeight();
        }
      }, 800);
    }
    /* INT v24: removed 60ms auto-fix on thumbnail click.
       Per diagnostic: this was the second setGallerySize trigger
       that caused VP to oscillate between stale offsetHeight values.
       Flickity's native select handles layout correctly — our
       container-height fix now runs only on int:gallery:settled (debounced)
       and window resize. */

    /* Kill Tailwind transition-opacity duration-300 on gallery imgs via JS.
       Runs on every VIA settle to catch newly injected slide elements. */
    (function () {
      function _killImgTransitions() {
        var gss = document.querySelector('[data-product-slideshow]');
        if (!gss) return;
        gss.querySelectorAll('[data-media-slide] img').forEach(function (img) {
          img.style.setProperty('transition', 'none', 'important');
          img.style.setProperty('animation', 'none', 'important');
        });
      }
      document.addEventListener('int:gallery:settled', _killImgTransitions);
      [200, 800, 2000].forEach(function (ms) { setTimeout(_killImgTransitions, ms); });
    })();

    (function () {
      function _patchThumbScroll() {
        var found = document.querySelectorAll('.media__thumb__wrapper, .media__thumb__holder');
        found.forEach(function (el) {
          if (el.__intSnapScroll) return;
          el.__intSnapScroll = true;
          var _orig = el.scrollTo;
          el.scrollTo = function (x) {
            if (x && typeof x === 'object' && x.behavior === 'smooth') {
              x = { top: x.top, left: x.left, behavior: 'instant' };
            }
            return _orig.apply(this, arguments);
          };
          /* Also intercept scrollLeft/scrollTop direct assignment paths */
          el.style.scrollBehavior = 'auto';
        });
        /* Window-level sentinel — survives DOM replacement */
        if (found.length > 0) window.__intSnapScrollApplied = true;
      }
      /* Re-patch on every int:gallery:settled — VIA may replace the DOM node */
      document.addEventListener('int:gallery:settled', _patchThumbScroll);
      /* MutationObserver catches SA-patch thumb wrapper replacement */
      var _thumbArea = document.querySelector('.product__media__wrapper, .product_media__wrapper');
      if (_thumbArea) {
        new MutationObserver(function () {
          var tw = _thumbArea.querySelector('.media__thumb__wrapper, .media__thumb__holder');
          if (tw && !tw.__intSnapScroll) _patchThumbScroll();
        }).observe(_thumbArea, { childList: true, subtree: true });
      }
      [300, 1000, 2500].forEach(function (ms) { setTimeout(_patchThumbScroll, ms); });
    })();

    /* ── Mirror Frame Size selector (mobile gallery → real popout) v2 ── */
    var _mirrorSel = document.getElementById('int-gallery-framesize-select');
    if (_mirrorSel) {
      _mirrorSel.addEventListener('change', function() {
        var val = _mirrorSel.value;
        var popoutOption = document.querySelector(
          '.select-popout__option[data-value="' + val.replace(/"/g, '\\"') + '"]'
        );
        if (popoutOption) {
          popoutOption.click();
          return;
        }
        /* Fallback: try radio inputs */
        document.querySelectorAll('input[type="radio"]').forEach(function(r) {
          if (r.value === val) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
      document.addEventListener('variant:change', function(e) {
        if (!e.detail || !e.detail.variant) return;
        var v = e.detail.variant;
        var pt = v.public_title || v.title || '';
        _mirrorSel.querySelectorAll('option').forEach(function(opt) {
          if (pt.indexOf(opt.value) !== -1) _mirrorSel.value = opt.value;
        });
      });
    }

  })();
  